module.exports = __webpack_public_path__ + "img/PDCA教学模型@2x.4f31a734.png";